module.exports = __webpack_public_path__ + "static/img/detect03.4dde4d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/technology/images/detect03.png
// module id = 577
// module chunks = 4